<template>
  <div class="mobile-addons">
    <transition name="fade" mode="out-in">
      <!-- TODO dodati on error stanje i retry event -->
      <loader-with-message v-if="dataLoading" :key="'loader'" />
      <tabs v-else-if="tabCategories.length && !dataLoading"
            v-model="selectedTab"
            :key="'tabs'"
            hide-tabs>
        <tab-page v-for="(tab, index) in tabCategories"
                  :key="'tabPage'+index"
                  :name="tab"
                  :label="tab">
          <addon-list v-if="currentlyDisplayedAddons.length"
                      :addon-data="currentlyDisplayedAddons"
                      :confirmationLoader="confirmationLoader"
                      ref="addonList"
                      @confirm-activation="activateAddonsApi"
                      @confirm-deactivation="deactivateAddonsApi"/>
          <div v-else
               :key="'no-addons'"
               class="no-addons">
            <img src="/assets/images/no-results.svg" width="112" height="112" alt=""/>
            <h3 class="title">{{ $t('addons.noAddonsTitle') }}</h3>
          </div>
        </tab-page>
      </tabs>
    </transition>
  </div>
</template>

<script>
import TabPage from '@/components/common/tabs/tabPage'
import Tabs from '@/components/common/tabs/tabs'
import errorMessageHandler from '@/mixins/errorMessageHandler'
import AddonList from '@/components/addons/addon-list'
import addonsActivation from '@/mixins/addonsActivation'
import selectionBlockEvents from '@/mixins/selectionBlockEvents'
import LoaderWithMessage from '@/components/common/loader-with-message'

export default {
  name: 'mobile-addons',
  components: { LoaderWithMessage, AddonList, Tabs, TabPage },
  props: {
    resourcesData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      selectedTab: '',
      addonCategories: [],
      tabCategories: [],
      dataLoading: true, // da bi se odmah pokrenuo loader
      confirmationLoader: false
    }
  },
  mixins: [errorMessageHandler, addonsActivation, selectionBlockEvents],
  computed: {
    currentlyDisplayedAddons () {
      return this.addonCategories.filter(category => category.name === this.selectedTab)
    }
  },
  methods: {
    fetchAddons () {
      this.dataLoading = true
      const id = this.$props.resourcesData.subscriberIdentity

      if (!id) return

      this.$apiRequest.get('user/services/addons/mobile?subscriberIdentity=' + id)
        .then(response => {
          if (response.data.categories && response.data.categories.length) {
            this.addonCategories = response.data.categories || []
            this.tabCategories = response.data.categories.map(category => category.name)
            this.$emit('add-tabs', this.tabCategories)
          }
        })
        .catch(e => {
          this.handleErrorMessage(e.response.data)
        })
        .finally(() => {
          this.dataLoading = false
          this.$nextTick(() => {
            this.unblockSidebarSelection(false)
          })
        })
    },
    initTabChangeListener () {
      this.$on('tab-change', (tabName) => {
        this.selectedTab = tabName
      })
    },
    removeTabChangeListener () {
      this.$off('tab-change')
    }
  },
  mounted () {
    this.initTabChangeListener()
    this.fetchAddons()
  },
  beforeDestroy () {
    this.removeTabChangeListener()
  }
}
</script>

<style scoped lang="scss">
.mobile-addons {
  padding: 2rem 0 4rem;
}
</style>
